import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';
import { EncriptacionService } from './encriptacion.service';

@Injectable({ providedIn: 'root' })
export class InscripcionConvenioService {

  constructor(
    public http: HttpClient,
    public router: Router,
    private encriptacionService: EncriptacionService,
    public _errors: ErrorsService
  ) { }

  async getVerificarCanConvenio() {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/getVerificarCanConvenio', JSON.stringify({}), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postCreateUpdateCartSubscription(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postCreateUpdateCartSubscription', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postUpdateStatusCart(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postUpdateStatusCart', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postCreatePaySubscription(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postCreatePaySubscription', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postComenzarPago(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postComenzarPago', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
  async postComenzarPagoVP(params: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    try {
      const data = await this.http
        .post(URL_SERVICIOS + '/postComenzarPagoVP', JSON.stringify(params), httpOptions)
        .toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getCartSubscription(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/getCartSubscription', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getSellers() {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/getSellers', httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postSendMailSellerPaciente(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postSendMailSellerPaciente', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getPreAprovallMercadoPago(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/getPreAprovallMercadoPago', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
  async getSubscripcionVirtualPos(params: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    try {
      const data = await this.http
        .post(URL_SERVICIOS + '/getSubscripcionVirtualPos', JSON.stringify(params), httpOptions)
        .toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }


  async postAddbeneficiaryPlanSubsMP(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postAddbeneficiaryPlanSubsMP', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postEditBeneficiarySubs(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postEditBeneficiarySubs', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postModifyPlanSubsMP(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postModifyPlanSubsMP', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
  async postModifyPlanSubsVP(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postModifyPlanSubsVP', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postCancelSubscription(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postCancelSubscription', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postBenPlanExist(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postBenPlanExist', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }

  async postChangeCardPayPlan(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postChangeCardPayPlan', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
  async postChangeCardVP(params: any) {
    const httpOptions = { headers: new HttpHeaders({ 'authorization': sessionStorage.getItem('token'), 'Content-Type': 'application/json' }) };
    try {
      const data = await this.http.post(URL_SERVICIOS + '/postChangeCardVP', JSON.stringify(params), httpOptions).toPromise();
      return data;
    } catch (error) {
      throw error;
    }
  }
  async getListarContrataciones({
    cusBenCusId = null,
    subCarCreatedFrom = null,
    subCarCreatedTo = null
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    const params = {
      cusBenCusId,
      subCarCreatedFrom,
      subCarCreatedTo
    };

    try {
      return await this.http
        .post(URL_SERVICIOS + '/getListarContrataciones', params, httpOptions)
        .toPromise();
    } catch (error) {
      console.error('[getListarContrataciones] Error:', error);
      this._errors.requestError(error);
      throw error;
    }
  }

  async getListarSuscripciones({
    cusBenCusId = null,
    subCarCreatedFrom = null,
    subCarCreatedTo = null
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };

    const params = {
      cusBenCusId,
      subCarCreatedFrom,
      subCarCreatedTo
    };

    try {
      return await this.http
        .post(URL_SERVICIOS + '/getListarSuscripciones', params, httpOptions)
        .toPromise();
    } catch (error) {
      console.error('[getListarSuscripciones] Error:', error);
      this._errors.requestError(error);
      throw error;
    }
  }

async postGeneratePayButton(data: { subsId: number; providerPay: string }): Promise<any> {
  const httpOptions = {
    headers: new HttpHeaders({
      // authorization: sessionStorage.getItem('token') || '',
      'Content-Type': 'application/json'
    })
  };

  try {
    return await this.http.post(
      URL_SERVICIOS + '/postGeneratePayButton',
      JSON.stringify(data),
      httpOptions
    ).toPromise();
  } catch (error) {
    throw error;
  }
}



}
